import React from 'react'
import { jwtDecode } from "jwt-decode"
import "./Normas.scss"
// components
import VistaAdminNormas from '../../components/Normas/VistaAdminNormas'
import VistaConsultoraNormas from '../../components/Normas/VistaConsultoraNormas'
import VistaEmpresaNormas from '../../components/Normas/VistaEmpresaNormas'

function HomeNormas() {
  const auth = localStorage.getItem("token")
  const jwtParse = jwtDecode(auth)
  const USER = jwtParse.apirest.objeto

  const title = (
    <>
      <div className='section__header d-flex flex-row align-items-end mb-4'>
        <i className='bi bi-patch-check me-2'></i>
        <h4 className='m-0'>Normas ISO</h4>
      </div>
    </>
  )

  if(USER.puesto === 1) {
      return (
          <div className='home__normas section'>
              {title}
              <VistaAdminNormas user={USER}/>
          </div>
      )
  }

  if(USER.puesto === 2) {
      return (
          <div className='home__normas section'>
              {title}
              <VistaConsultoraNormas user={USER}/>
          </div>
      )
  }

  if(USER.puesto === 3 || USER.puesto === 4 || USER.puesto === 5 || USER.puesto === 6 || USER.puesto === 7) {
      return (
          <div className={`home__normas ${USER.puesto > 5 ? 'home__normas--ext' : ''} section`}>
              {title}
              <VistaEmpresaNormas user={USER}/>
          </div>
      )
  }
}

export default HomeNormas